module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_m_normal.fcefe89a.png";